import { render } from "./GenericContent.vue?vue&type=template&id=123201a3&scoped=true&lang=html"
import script from "./GenericContent.vue?vue&type=script&lang=js"
export * from "./GenericContent.vue?vue&type=script&lang=js"

import "./GenericContent.vue?vue&type=style&index=0&id=123201a3&scoped=true&deep=true&lang=scss"
script.render = render
script.__scopeId = "data-v-123201a3"

export default script